export function pluralize(n: number, singular: string, plural: string) {
    const s = n.toString();
    return (n === 1 ? s + " " + singular : s + " " + plural);
}